// src/api/interviewApi.js
import apiClient from './axios';

const interviewApi = {
  // ── Get list (paginated) ────────────────────────────────────────────────
  getInterviewApplications: async (params = {}) => {
    const response = await apiClient.get('/interview-form/', { params });
    return response.data; // returns { status, success, data: [], pagination, errors }
  },

  // ── Create new application ──────────────────────────────────────────────
  createInterviewApplication: async (formData) => {
    const response = await apiClient.post('/interview-form/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // ── Update existing application ─────────────────────────────────────────
  updateInterviewApplication: async (id, formData) => {
    const response = await apiClient.patch(`/interview-form/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // ── Delete application ──────────────────────────────────────────────────
  deleteInterviewApplication: async (id) => {
    await apiClient.delete(`/interview-form/${id}/`);
  },

  // ── Approve application ─────────────────────────────────────────────────
  approveInterviewApplication: async (id, remarks = '') => {
    const response = await apiClient.post(`/interview-form/${id}/approve/`, { remarks });
    return response.data;
  },

  // ── Reject application ──────────────────────────────────────────────────
  rejectInterviewApplication: async (id, remarks) => {
    const response = await apiClient.post(`/interview-form/${id}/reject/`, { remarks });
    return response.data;
  },

  // ── Export (if implemented in backend) ──────────────────────────────────
  exportInterviewApplications: async () => {
    const response = await apiClient.get('/interview-form/export/', { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'interview-applications.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  // ── Public submit (no auth required - use if you have separate public endpoint) ──
  submitPublicInterviewForm: async (formData) => {
    const response = await apiClient.post('/interview-form/open_form/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default interviewApi;